import theme from "../utils/styles";

const data = {
  cards: [
    {
      title: "Experienced Based Learning",
      img: "/img/mission/learning.png",
      text: "Helping participants of our programs engage in a learning environment that invites them to analyse their learning experience by reflecting, evaluating and reconstructing it.",
      color: theme.gradients.orange,
    },
    {
      title: "Knowledge Empowerment",
      img: "/img/mission/knowledge.png",
      text: "Being a source for knowledge empowerment for our community in area of Life Sciences. Using our platform to bring in experts from multi-disciplinary backgrounds.",
      color: theme.gradients.blue,
    },
    {
      title: "Community Development",
      img: "/img/mission/community.png",
      text: "Collaborating with the local science communication and STEM education organizations to help build a scientific culture in Pakistan.",
      color: theme.gradients.pink,
    },
    {
      title: "Collective Action",
      img: "/img/mission/action.png",
      text: "Advocating for promoting scientific literacy in Pakistan and advising policy for promotion of Life Sciences education, research and development.",
      color: theme.gradients.indigo,
    },
  ],
};

export default data;
